import {NgModule} from '@angular/core';
import {CampaignEnquireFooterComponent} from './campaign-enquire-footer.component';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {BorrowerEnquireNowFormComponent} from '../../views/borrower-enquire-now-form/borrower-enquire-now-form.component';
import {EnquireNowFormModule} from '../../views/enquire-now-form/enquire-now-form.module';
import {MatButtonModule, MatFormFieldModule} from '@angular/material';

@NgModule({
    imports: [FormsModule, CommonModule, MatSelectModule, MatFormFieldModule, MatInputModule, FormsModule, MatInputModule, MatButtonModule, EnquireNowFormModule],
    declarations: [CampaignEnquireFooterComponent, BorrowerEnquireNowFormComponent],
    exports: [CampaignEnquireFooterComponent, BorrowerEnquireNowFormComponent]
})
export class CampaignEnquireFooterModule {
}
